__webpack_require__.p = "/activities-avatar/referrals-hub/";